import { setup, fromPromise } from 'xstate';
import { NeuroIDResponse } from '@ads-bread/shared/bread/codecs';
import { ActorErrorParams } from '../../../../lib/types';
import { FraudAlloyMachineEvents } from './types/events';
import { InitializingNeuroIdResult } from './types/actors';
import { getInitializeNeuroIdParams, getServiceErrorParams } from './actions';
import { assignNeuroIdTokens, emitFraudAlloyMachineReady } from './assigns';

export interface FraudAlloyContext {
  neuroIdTokens: NeuroIDResponse | undefined;
}

export const fraudAlloyMachine = setup({
  types: {
    context: {} as FraudAlloyContext,
    events: {} as FraudAlloyMachineEvents,
  },
  actions: {
    assignNeuroIdTokens,
    emitFraudAlloyMachineReady,
    logError: (_, __: ActorErrorParams): void => {
      throw new Error('Not implemented');
    },
  },
  actors: {
    initializeNeuroId: fromPromise<InitializingNeuroIdResult>(async () => {
      throw new Error('Not implemented');
    }),
  },
}).createMachine({
  id: 'fraudAlloyMachine',
  context: {
    neuroIdTokens: undefined,
  },
  initial: 'initializingNeuroId',
  on: {
    SEND_INITIALIZE_NEURO_ID: {
      target: '.initializingNeuroId',
    },
  },
  states: {
    initializingNeuroId: {
      invoke: {
        src: 'initializeNeuroId',
        onDone: [
          {
            actions: [
              {
                type: 'assignNeuroIdTokens',
                params: getInitializeNeuroIdParams,
              },
            ],
            target: 'ready',
          },
        ],
        onError: [
          {
            actions: [
              {
                type: 'logError',
                params: getServiceErrorParams,
              },
            ],
            // Always go to ready
            target: 'ready',
          },
        ],
      },
    },
    ready: {
      entry: ['emitFraudAlloyMachineReady'],
    },
  },
});
